package com.patronat.top.core.presentation

import com.patronat.top.core.utils.UiText
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.*

// Модель в Core (бізнес-сущність сповіщення)
data class AppNotification(
    val title: UiText,
    val message: UiText,
    val type: NotificationType = NotificationType.ERROR
)

enum class NotificationType { ERROR, WARNING, SUCCESS }

class AlertController {
    private val _notification = MutableStateFlow<AppNotification?>(null)
    val notification = _notification.asStateFlow()

    private var dismissJob: Job? = null
    private val scope = CoroutineScope(Dispatchers.Main)

    fun show(
        title: UiText,
        message: UiText,
        type: NotificationType = NotificationType.ERROR
    ) {
        dismissJob?.cancel()

        _notification.update {
            AppNotification(title, message, type)
        }

        dismissJob = scope.launch {
            delay(5000L)
            _notification.update { null }
        }
    }
    fun show(title: String, message: String, type: NotificationType = NotificationType.ERROR) {
        show(UiText.DynamicString(title), UiText.DynamicString(message), type)
    }
}